import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Users, Wine, Mail, Inbox, Bell, Loader2 } from 'lucide-react';
import { adminStats } from '../../lib/api';

const StatCard = ({ icon: Icon, label, value, subtitle, color = '#c9a063', to }) => {
  const Content = (
    <div className="gd-card p-6 hover:border-[#c9a063]/50 transition-colors cursor-pointer">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 mb-2">{label}</div>
          <div className="font-serif-display text-4xl text-white">{value}</div>
          {subtitle && <div className="text-[#c9a063] text-xs mt-1">{subtitle}</div>}
        </div>
        <div className="w-11 h-11 border flex items-center justify-center" style={{ borderColor: `${color}66`, color }}><Icon size={18} /></div>
      </div>
    </div>
  );
  return to ? <Link to={to}>{Content}</Link> : Content;
};

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { adminStats().then(setStats).catch(() => {}); }, []);

  if (!stats) return <div className="p-10 flex items-center justify-center text-[#c9a063]"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="p-6 md:p-10">
      <div className="mb-8">
        <h1 className="font-serif-display text-3xl text-white mb-1">Dashboard</h1>
        <p className="text-white/55">Resumen del estado de Golf Divino</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <StatCard icon={Calendar} label="Experiencias" value={stats.experiences} to="/admin/experiencias" />
        <StatCard icon={Users} label="Equipo" value={stats.team} to="/admin/equipo" />
        <StatCard icon={Wine} label="Colaboradores" value={stats.collaborators} to="/admin/colaboradores" />
        <StatCard icon={Mail} label="Newsletter" value={stats.newsletter} to="/admin/newsletter" />
        <StatCard icon={Inbox} label="Inscripciones" value={stats.inscriptions} subtitle={stats.inscriptions_unread ? `${stats.inscriptions_unread} sin leer` : 'Todo leído'} to="/admin/inscripciones" />
        <StatCard icon={Bell} label="Contactos" value={stats.contacts} subtitle={stats.contacts_unread ? `${stats.contacts_unread} sin leer` : 'Todo leído'} to="/admin/contactos" />
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
        <Link to="/admin/experiencias" className="gd-card p-6 hover:border-[#c9a063]/50 transition-colors">
          <div className="text-[#c9a063] gd-eyebrow mb-2">Acción rápida</div>
          <h3 className="font-serif-display text-xl text-white mb-1">Crear nueva experiencia</h3>
          <p className="text-white/55 text-sm">Añade un torneo o cata al calendario.</p>
        </Link>
        <Link to="/admin/ajustes" className="gd-card p-6 hover:border-[#c9a063]/50 transition-colors">
          <div className="text-[#c9a063] gd-eyebrow mb-2">Configuración</div>
          <h3 className="font-serif-display text-xl text-white mb-1">Ajustes del sitio</h3>
          <p className="text-white/55 text-sm">Cambia textos, imágenes del hero, contacto y redes.</p>
        </Link>
      </div>
    </div>
  );
}
